// Textos dels anuncis per zona: informe de desequilibri, esborranys i
// plantilles. Es registren amb la resta de vocabularis a AppComponent.
export const locale = {
  lang: 'ca',
  data: {
    ZONE_ADS: {
      ZONE: 'Zona',
      TARGET_ROLE: 'Adreçat a',
      STATUS_LABEL: 'Estat',
      BUDGET: 'Pressupost',
      BUDGET_EUROS: 'Pressupost (€)',
      DURATION: 'Durada',
      DURATION_DAYS: 'Durada (dies)',
      DAYS: '{{count}} d',
      RADIUS_KM: 'Radi (km)',
      ADVANTAGE: 'Audiència Advantage+ de Meta',
      ADVANTAGE_HINT: 'Meta pot ampliar l’edat i els interessos per millorar el rendiment; la zona continua sent un límit.',
      ROUTINES: 'Rutines',
      CREATED_AT: 'Creat',
      UPDATED_AT: 'Actualitzada',
      ACTIONS: 'Accions',
      OPEN: 'Obrir',
      OPEN_MAPS: 'Veure a Google Maps',
      NO_ZONE_LABEL: 'Sense nom de zona',
      FILTER_ALL_STATUSES: 'Tots els estats',
      FILTER_ALL_ROLES: 'Tots els destinataris',
      CLEAR_FILTERS: 'Netejar filtres',
      PREVIOUS: 'Anterior',
      NEXT: 'Següent',
      RETRY: 'Tornar-ho a provar',
      RELOAD: 'Recarregar',
      LOADING: 'Carregant…',
      SHOW: 'Veure',
      HIDE: 'Amagar',
      ACCEPT: 'Acceptar',
      CANCEL: 'Cancel·lar',
      CLOSE: 'Tancar',
      SAVING: 'Desant…',
      SAVE_CHANGES: 'Desar els canvis',
      REVIEW_FIELDS: 'Revisa els camps marcats.',
      ERROR_FORBIDDEN_ACTION: 'No tens permís per fer això.',

      ROLE: {
        driver: 'Conductors',
        rider: 'Passatgers',
        both: 'Conductors i passatgers',
      },
      STATUS: {
        draft: 'Esborrany',
        approved: 'Aprovat',
        publishing: 'Publicant',
        publish_failed: 'Publicació fallida',
        published: 'Publicat',
        finished: 'Finalitzat',
        rejected: 'Rebutjat',
        meta_rejected: 'Rebutjat per Meta',
      },

      VALIDATION: {
        REQUIRED: 'Aquest camp és obligatori.',
        INTEGER: 'Ha de ser un nombre enter.',
        RANGE: 'Ha d’estar entre {{min}} i {{max}}.',
        EURO_CENTS: 'Fes servir com a màxim dos decimals.',
        MIN_BUDGET: 'El pressupost mínim és {{min}}.',
        HTTPS_URL: 'Ha de ser una adreça https://.',
        MAX_LENGTH: 'Com a màxim {{max}} caràcters.',
      },

      ERRORS: {
        zone_occupied: 'Aquesta zona ja té un esborrany obert per a aquest destinatari.',
        already_decided: 'L’esborrany ja no està pendent de decisió: ara està «{{status}}».',
        not_editable: 'L’esborrany ja no es pot editar: ara està «{{status}}».',
        not_publishable: 'L’esborrany no es pot publicar: ara està «{{status}}».',
        incomplete_draft: 'A l’esborrany li falten dades per aprovar-lo.',
        meta_not_configured: 'La publicació a Meta no està configurada.',
        template_in_use: 'Algun esborrany fa servir aquesta plantilla.',
        not_found: 'L’esborrany ja no existeix.',
        draft_in_meta: 'Aquest esborrany va arribar a Meta: no es pot eliminar, només desactivar-lo amb «Rebutjar».',
      },
      APPROVE_MISSING: {
        template_id: 'Una plantilla activa per al mateix destinatari que l’esborrany',
        zone_label: 'El nom de la zona',
      },
      META_MISSING: {
        SERVICES_META_API_VERSION: 'Versió de l’API de Meta (configuració del servidor)',
        SERVICES_META_AD_ACCOUNT_ID: 'Compte publicitari de Meta (configuració del servidor)',
        SERVICES_META_PAGE_ID: 'Pàgina de Facebook (configuració del servidor)',
        SERVICES_META_INSTAGRAM_USER_ID: 'Compte d’Instagram (configuració del servidor)',
        SERVICES_META_ACCESS_TOKEN: 'Token d’accés de Meta (configuració del servidor)',
        SERVICES_META_APP_SECRET: 'Secret de l’app de Meta (configuració del servidor)',
        EFFECTS_META: 'Les crides a Meta estan desactivades en aquest entorn',
        ZONE_AD_SETTINGS_DSA_PAYOR: 'Qui paga l’anunci (DSA), a Ajustos',
        ZONE_AD_SETTINGS_DSA_BENEFICIARY: 'A qui beneficia l’anunci (DSA), a Ajustos',
      },

      IMBALANCE: {
        TITLE: 'Cel·les amb més conductors que passatgers o al revés',
        SUB: 'Rutines vigents per cel·la H3: cada usuari compta a la cel·la del seu origen i a la de la seva destinació.',
        RESOLUTION: 'Resolució H3',
        RESOLUTION_OPTION: 'Resolució {{resolution}}',
        MIN_USERS: 'Mín. usuaris',
        MIN_USERS_INVALID: 'Posa un nombre enter a partir d’1.',
        SORT_LABEL: 'Ordre',
        SORT: {
          ratio_desc: 'Més conductors per passatger',
          ratio_asc: 'Més passatgers per conductor',
          drivers_desc: 'Més conductors',
          riders_desc: 'Més passatgers',
        },
        LIMIT: 'Cel·les',
        LIMIT_OPTION: '{{count}} cel·les',
        SEE_DRAFTS: 'Veure esborranys',
        DRIVERS: 'Conductors',
        RIDERS: 'Passatgers',
        TOTAL_SEATS: 'Places',
        AVERAGE_SEATS: 'Places per conductor',
        RATIO: 'Ràtio',
        RATIO_HINT: 'Conductors ÷ (passatgers + 1)',
        SEATS_RATIO: 'Ràtio de places',
        SEATS_RATIO_HINT: 'Places ÷ (passatgers + 1)',
        LACKING_ROLE: 'Falta',
        LACKING: {
          driver: 'Falten conductors',
          rider: 'Falten passatgers',
          none: 'Equilibrada',
        },
        NO_LOCALITY: 'Sense localitat',
        LOAD_ERROR: 'No s’ha pogut carregar l’informe de desequilibri.',
        EMPTY: 'Cap cel·la arriba al mínim d’usuaris.',
        SHOWING: 'Mostrant {{shown}} de {{total}} cel·les',
        MAP_TOOLTIP: '{{drivers}} conductors · {{riders}} passatgers',
        ZOOM_IN: 'Apropar',
        ZOOM_OUT: 'Allunyar',
        CREATE_DRAFT: 'Crear esborrany',
        CREATE_TITLE: 'Crear esborrany d’anunci',
        ROLE_SUGGESTED: 'Segons l’informe: {{lacking}}.',
        OPTIONAL_TITLE: 'Valors de l’anunci',
        OPTIONAL_HINT: 'Opcionals: el que deixis buit es pren dels ajustos d’anuncis per zona.',
        FROM_SETTINGS: 'Dels ajustos',
        ADVANTAGE_ON: 'Activada',
        ADVANTAGE_OFF: 'Desactivada',
        CREATE_SUBMIT: 'Crear esborrany',
        CREATING: 'Creant…',
        CREATE_ERROR: 'No s’ha pogut crear l’esborrany.',
        OPEN_OCCUPIED: 'Veure l’esborrany obert',
      },

      DRAFTS: {
        LIST_TITLE: 'Esborranys d’anuncis',
        LIST_SUB: 'Els genera el sistema o es creen des de l’informe. Obre’ls per revisar-los, aprovar-los i publicar-los.',
        FROM_REPORT: 'Informe de desequilibri',
        LOAD_ERROR: 'No s’han pogut carregar els esborranys.',
        EMPTY: 'Encara no hi ha esborranys.',
        EMPTY_FILTERED: 'Cap esborrany compleix els filtres.',
        SHOWING: 'Mostrant {{shown}} de {{total}} esborranys',
        PER_PAGE: '{{count}} per pàgina',
        PER_PAGE_LABEL: 'Esborranys per pàgina',
      },

      DETAIL: {
        TITLE: 'Esborrany d’anunci',
        BACK: 'Tornar al llistat',
        LOAD_NOT_FOUND: 'Aquest esborrany no existeix.',
        LOAD_FORBIDDEN: 'No tens permís per veure aquest esborrany.',
        LOAD_FAILED: 'No s’ha pogut carregar l’esborrany.',
        RESOLUTION: 'Resolució {{resolution}}',
        APPROVED_AT: 'Aprovat',
        PUBLISHED_AT: 'Publicat',
        CLOSED_AT: 'Tancat',
        ESTIMATED_SIGNUPS: 'Registres estimats',
        DECIDED_BY: 'Decidit per',
        REJECTED_REASON: 'Motiu del rebuig',

        PUBLISHING_TITLE: 'Publicant a Meta',
        PUBLISHING_TEXT: 'La campanya s’està creant en segon pla. Recarrega d’aquí a uns moments per veure’n el resultat.',
        PUBLISH_ERROR_TITLE: 'L’última publicació ha fallat',

        READ_ONLY_TITLE: 'Només es pot editar en esborrany',
        READ_ONLY_TEXT: 'Un cop aprovat, l’anunci ja no canvia: el que veus és el que es publica.',
        AD_TITLE: 'Anunci',
        AD_SUB: 'La plantilla posa la imatge i els textos; el nom de la zona substitueix el seu marcador.',
        TEMPLATE: 'Plantilla',
        TEMPLATE_HINT: 'Plantilles actives per a {{role}}.',
        TEMPLATE_INACTIVE: '{{name}} (desactivada)',
        TEMPLATE_OTHER: 'Plantilla actual (no és a la llista)',
        TEMPLATES_ERROR: 'No s’han pogut carregar les plantilles.',
        ZONE_LABEL: 'Nom de la zona',
        ZONE_LABEL_HINT: 'Com sortirà a l’anunci, p. ex. «Sant Cugat».',
        AREA_TITLE: 'Àrea de l’anunci',
        AREA_SUB: 'Cercle on es mostra l’anunci i zones que s’hi exclouen.',
        CENTER_LAT: 'Latitud del centre',
        CENTER_LONG: 'Longitud del centre',
        EXCLUSIONS: 'Exclusions',
        EXCLUSIONS_HINT: 'Cercles on no es mostra l’anunci. Com a màxim {{max}}.',
        NO_EXCLUSIONS: 'Sense exclusions.',
        ADD_EXCLUSION: 'Afegir exclusió',
        REMOVE_EXCLUSION: 'Treure exclusió',
        EXCLUSION_OUTSIDE: 'Aquesta exclusió queda fora de l’àrea de l’anunci.',
        MAP_HINT: 'Arrossega el centre o la vora d’un cercle per moure’l o canviar-ne el radi. Prem dins de l’àrea per afegir una exclusió d’1 km.',
        MAP_MOVE: 'Arrossega per moure',
        MAP_RESIZE: 'Arrossega per canviar el radi',
        ZOOM_IN: 'Apropar',
        ZOOM_OUT: 'Allunyar',
        BUDGET_TITLE: 'Pressupost i durada',
        BUDGET_SUB: 'Pressupost total de la campanya i dies que estarà activa.',
        DISCARD: 'Descartar els canvis',
        NO_CHANGES: 'No hi ha canvis per desar',
        SAVED: 'Esborrany desat',
        SAVE_ERROR: 'No s’ha pogut desar l’esborrany.',
        SAVE_FIRST: 'Desa o descarta els canvis abans d’aprovar',

        PREVIEW_TITLE: 'Previsualització',
        PREVIEW_SUB: 'Textos i imatge amb el nom de la zona posat. Canvia al moment amb el formulari, abans de desar.',
        NO_TEMPLATE: 'Tria una plantilla per veure l’anunci.',
        SIGNUPS_TITLE: 'Registres atribuïts',
        SIGNUPS_SUB: 'Usuaris que han arribat des d’aquest anunci, segons el rol de la seva primera rutina.',
        SIGNUPS_TOTAL: 'Total',
        SIGNUPS_NO_ROUTINE: 'Sense rutina',
        META_TITLE: 'Meta',
        META_SYNCED: 'Sincronitzat el {{date}}.',
        META_NOT_SYNCED: 'Encara sense mètriques sincronitzades.',
        META_CAMPAIGN: 'Campanya',
        META_FACEBOOK_AD: 'Anunci de Facebook',
        META_INSTAGRAM_AD: 'Anunci d’Instagram',
        META_FACEBOOK_STATUS: 'Estat a Facebook',
        META_INSTAGRAM_STATUS: 'Estat a Instagram',
        META_SPEND: 'Gastat',
        META_IMPRESSIONS: 'Impressions',
        META_REACH: 'Abast',
        META_CLICKS: 'Clics a l’enllaç',
        META_FEEDBACK: 'Revisió de Meta',

        APPROVE: 'Aprovar',
        APPROVE_TITLE: 'Aprovar l’esborrany',
        APPROVE_TEXT: 'Quedarà a punt per publicar i ja no es podrà editar.',
        APPROVING: 'Aprovant…',
        APPROVED: 'Aprovat',
        APPROVE_INCOMPLETE: 'Cal completar l’esborrany per aprovar-lo',
        APPROVE_ERROR: 'No s’ha pogut aprovar l’esborrany',
        REJECT: 'Rebutjar',
        REJECT_HINT: 'Tanca l’esborrany i el deixa a l’historial: la zona espera el període dels ajustos abans d’un altre.',
        DELETE: 'Eliminar',
        DELETE_HINT: 'L’esborra per sempre, amb les seves rutines. Només es pot si mai va arribar a Meta.',
        DELETE_TITLE: 'Eliminar l’esborrany',
        DELETE_TEXT: 'S’esborra per sempre, amb les seves rutines. Si només vols que no es publiqui, rebutja’l.',
        DELETING: 'Eliminant…',
        DELETED: 'Eliminat',
        DELETE_ERROR: 'No s’ha pogut eliminar l’esborrany',
        REJECT_TITLE: 'Rebutjar l’esborrany',
        REJECT_TEXT: 'Es tanca i no es publicarà.',
        REJECT_TEXT_PUBLISHING: 'Es tanca. El que ja s’hagi creat a Meta s’hi queda: no es pausa ni s’esborra.',
        REJECT_REASON: 'Motiu (opcional)',
        REJECTING: 'Rebutjant…',
        REJECTED: 'Rebutjat',
        REJECT_ERROR: 'No s’ha pogut rebutjar l’esborrany',
        PUBLISH: 'Publicar a Meta',
        PUBLISH_RETRY: 'Tornar a publicar',
        PUBLISH_TITLE: 'Publicar a Meta',
        PUBLISH_TEXT: 'Es crearà una campanya real amb {{budget}} durant {{days}} dies.',
        PUBLISHING: 'Enviant…',
        PUBLISH_QUEUED: 'A la cua',
        PUBLISH_ERROR: 'No s’ha pogut publicar l’esborrany',
        META_NOT_CONFIGURED: 'Falta configurar la publicació a Meta',
        META_NOT_CONFIGURED_TEXT: 'Per publicar falta:',
        GO_TO_SETTINGS: 'Anar als ajustos',
      },

      TEMPLATES: {
        LIST_TITLE: 'Plantilles d’anunci',
        LIST_SUB: 'Imatge i textos dels anuncis. {{placeholder}} se substitueix pel nom de la zona.',
        NEW: 'Nova plantilla',
        NEW_TITLE: 'Nova plantilla',
        EDIT_TITLE: 'Editar plantilla',
        EDIT: 'Editar',
        DELETE: 'Eliminar',
        CREATE: 'Crear plantilla',
        NAME: 'Nom',
        NAME_HINT: 'Només per a l’equip; no surt a l’anunci.',
        ROLE_HINT: 'Només es pot fer servir en esborranys per al mateix destinatari.',
        HEADLINE: 'Títol',
        PRIMARY_TEXT: 'Text principal',
        PLACEHOLDER_HINT: 'Escriu {{placeholder}} on vagi el nom de la zona.',
        UNKNOWN_MARKERS: 'Aquests marcadors no se substitueixen i sortiran tal qual a l’anunci: {{markers}}. El de la zona és {{placeholder}}.',
        IMAGE_URL: 'URL de la imatge',
        IMAGE_URL_HINT: 'Adreça https d’una imatge ja publicada: no es pugen fitxers.',
        IMAGE_FAILED: 'No s’ha pogut carregar la imatge d’aquesta adreça.',
        ACTIVE_LABEL: 'Activa (es pot triar als esborranys)',
        STATE: 'Estat',
        ACTIVE: 'Activa',
        INACTIVE: 'Desactivada',
        LOAD_ERROR: 'No s’han pogut carregar les plantilles.',
        EMPTY: 'Encara no hi ha plantilles.',
        SHOWING: 'Mostrant {{shown}} de {{total}} plantilles',
        PER_PAGE: '{{count}} per pàgina',
        PER_PAGE_LABEL: 'Plantilles per pàgina',
        CREATED: 'Plantilla creada',
        UPDATED: 'Plantilla desada',
        SAVE_ERROR: 'No s’ha pogut desar la plantilla.',
        IN_USE_ROLE: 'No es pot canviar el destinatari: algun esborrany fa servir aquesta plantilla.',
        DELETE_TITLE: 'Eliminar «{{name}}»',
        DELETE_TEXT: 'La plantilla desapareix. Si només vols que no es triï, desactiva-la.',
        DELETE_CONFIRM: 'Eliminar plantilla',
        DELETING: 'Eliminant…',
        DELETED: 'Eliminada',
        DELETE_ERROR: 'No s’ha pogut eliminar la plantilla',
        IN_USE_DELETE: 'Algun esborrany la fa servir. Desactiva-la perquè no es triï en esborranys nous.',
      },
    },
  },
};
